export class TopicOrder {
  id: string;
  completed: boolean;
}
